import { db } from '../firebase';
import { collection, addDoc, doc, getDoc, getDocs, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { COLLECTION_COORDINATORS, SOURCE_SYSTEM, SCHEMA_VERSION } from '../shared/constants';

/**
 * Create a new coordinator account
 * 
 * IMPORTANT: This creates a Firestore document only.
 * The Firebase Auth user is created by the Cloud Function trigger.
 * The Cloud Function will automatically use the tempPassword if provided.
 */
export async function createCoordinator(coordinatorData) {
    try {
        const { email, password, ...profileData } = coordinatorData;

        // Create coordinator document in Firestore ONLY
        // The onCoordinatorCreated Cloud Function will create the Firebase Auth user
        const docRef = await addDoc(collection(db, COLLECTION_COORDINATORS), {
            ...profileData,
            email,
            tempPassword: password, // Pass to Cloud Function to set manual password
            passwordChanged: false,
            sourceSystem: SOURCE_SYSTEM,
            schemaVersion: SCHEMA_VERSION,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
        });

        console.log(`✅ Coordinator record created in Firestore: ${docRef.id}`);
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error('Error creating coordinator:', error);
        throw error;
    }
}

export async function getAllCoordinators() {
    try {
        const querySnapshot = await getDocs(collection(db, COLLECTION_COORDINATORS));
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
    } catch (error) {
        console.error('Error getting coordinators:', error);
        throw error;
    }
}

export async function getCoordinatorById(id) {
    try {
        const docRef = doc(db, COLLECTION_COORDINATORS, id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
        }
        return null;
    } catch (error) {
        console.error('Error getting coordinator:', error);
        throw error;
    }
}

export async function updateCoordinator(id, updates) {
    try {
        const docRef = doc(db, COLLECTION_COORDINATORS, id);
        await updateDoc(docRef, {
            ...updates,
            updatedAt: serverTimestamp(),
        });
        return { success: true };
    } catch (error) {
        console.error('Error updating coordinator:', error);
        throw error;
    }
}

export async function deleteCoordinator(id) {
    try {
        await deleteDoc(doc(db, COLLECTION_COORDINATORS, id));
        return { success: true };
    } catch (error) {
        console.error('Error deleting coordinator:', error);
        throw error;
    }
}
